var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriceTag3Fill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "price-tag-3-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.174 3.5L34.6732 5.85702L37.0302 22.3562L21.7095 37.6768C21.0587 38.3277 20.0035 38.3277 19.3525 37.6768L2.8534 21.1777C2.20251 20.5268 2.20251 19.4715 2.8534 18.8207L18.174 3.5ZM22.8882 17.6422C24.1898 18.9438 26.3003 18.9438 27.6022 17.6422C28.9038 16.3404 28.9038 14.2298 27.6022 12.9281C26.3003 11.6263 24.1898 11.6263 22.8882 12.9281C21.5863 14.2298 21.5863 16.3404 22.8882 17.6422Z",
    fill: "#006B5D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceTag3Fill);
export default __webpack_public_path__ + "static/media/price-tag-3-fill.613ad45e6accbebb068bf82a7cd8be99.svg";
export { ForwardRef as ReactComponent };